<template>
	<div class="border-b border-neutral-200 mb-6">
		<nav class="-mb-px flex space-x-8 overflow-x-auto" aria-label="Tabs">
			<router-link
				v-for="tab in tabs"
				:key="tab.id"
				v-slot="{ href, navigate }"
				:to="tab.link"
				custom
			>
				<a
					:href="href"
					class="whitespace-nowrap py-3 px-1 border-b-2 font-semibold"
					:class="
						isActive(tab)
							? 'text-yellow-700 border-yellow-500'
							: 'border-transparent text-neutral-500 hover:text-yellow-700 hover:border-yellow-500'
					"
					@click="navigate"
				>
					{{ tab.name }}
				</a>
			</router-link>
		</nav>
	</div>
</template>

<script>
import {
	isScheduleTabActive,
	scheduleSectionTabs,
} from '@/helper/scheduleSection';

export default {
	name: 'ScheduleSectionNav',
	computed: {
		tabs() {
			return scheduleSectionTabs(this.$route);
		},
	},
	methods: {
		isActive(tab) {
			return isScheduleTabActive(tab, this.$route);
		},
	},
};
</script>
